import { globalStyle, style } from '@vanilla-extract/css';

export const recommendationsElement = style({
  minWidth: '320px',
  '@media': {
    'only screen and (--mobile)': {
      minWidth: 'auto',
      overflowX: 'scroll',
    },
  },
});

export const inputText = style({
  color: 'var(--input-text-color)',
  '::placeholder': {
    color: 'var(--input-placeholder-text-color)',
    opacity: 0.7,
  },
});

export const selectAllLabel = style({
  color: 'var(--select-all-text-color)',
});

export const sponsoredText = style({
  color: 'var(--sponsored-text-color)',
});

export const submitButton = style({
  fontSize: '16px',
});

export const selectAllSwitchRoot = style({
  width: '34px',
  height: '20px',
  borderRadius: '9999px',
  position: 'relative',
});

export const listContainer = style({
  maxHeight: 'var(--list-max-height)',
  overflow: 'var(--list-overflow)',
  selectors: {
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
});

globalStyle(`[data-recommendations-modal="true"] ${listContainer}`, {
  '@media': {
    'only screen and (--mobile)': {
      maxHeight: '30vh',
      overflowY: 'scroll',
    },
  },
});

export const selectAllSwitchThumb = style({
  display: 'block',
  width: '16px',
  height: '16px',
  backgroundColor: 'var(--button-custom-text-color)',
  borderRadius: '9999px',
  transition: 'transform 100ms',
  transform: 'translateX(2px)',
  selectors: {
    "&[data-state='checked']": {
      transform: 'translateX(16px)',
    },
  },
});
